import React from "react";
import "./Work.css";

import yogurtImage from "./Images/yogurt.png";
import weatherImage from "./Images/weather.png";
import dictionaryImage from "./Images/dictionary.png";
import translationImage from "./Images/translation.png";

export default function Work() {
  return (
    <div className="Work">
      <div className="content-container container">
        <div className="content">
          <h1 className="mb-5">Take a look at what I've been working on!</h1>

          <div className="row">
            <div className="col-md-6 mb-4">
              <img
                src={yogurtImage}
                alt="Yogurt project"
                className="img-fluid mb-3 rounded"
              />

              <h3 className="text-center mb-0">Yogurt Project</h3>

              <p className="text-center text-muted">Built with HTML and CSS</p>
            </div>

            <div className="col-md-6 mb-4">
              <img
                src={weatherImage}
                alt="Weather project"
                className="img-fluid mb-3 rounded"
              />

              <h3 className="text-center mb-0">Weather Project</h3>
              <p className="text-center text-muted">
                Built with HTML, CSS and JavaScript
              </p>
            </div>

            <div className="col-md-6 mb-4">
              <img
                src={dictionaryImage}
                alt="Dictionary project"
                className="img-fluid mb-3 rounded"
              />

              <h3 className="text-center mb-0">Dictionary Project</h3>

              <p className="text-center text-muted">
                Built with HTML, CSS and React
              </p>
            </div>

            <div className="col-md-6 mb-4">
              <img
                src={translationImage}
                alt="Translation project"
                className="img-fluid mb-3 rounded"
              />

              <h3 className="text-center mb-0">Translation Project</h3>
              <p className="text-center text-muted">
                Built with HTML, CSS and React
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
